import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input", "preview", "fileName", "dropzone", "filename", "filesize"]

  // Legacy action — kept for existing usage
  handleFileSelect(event) {
    const file = event.target.files[0]

    if (file) {
      if (this.hasFileNameTarget) {
        this.fileNameTarget.textContent = file.name
      }

      if (this.hasPreviewTarget) {
        this.previewTarget.classList.remove("hidden")
      }

      const previewId = event.target.dataset.filePreviewPreviewId
      const filenameId = event.target.dataset.filePreviewFilenameId

      if (previewId) {
        const previewElement = document.getElementById(previewId)
        if (previewElement) previewElement.classList.remove("hidden")
      }

      if (filenameId) {
        const filenameElement = document.getElementById(filenameId)
        if (filenameElement) filenameElement.textContent = file.name
      }
    }
  }

  // Dropzone-style: swaps drop zone for a file indicator with clear button
  fileSelected() {
    const file = this.inputTarget.files[0]
    if (!file) return

    if (this.hasFilenameTarget) this.filenameTarget.textContent = file.name
    if (this.hasFilesizeTarget) this.filesizeTarget.textContent = this.formatSize(file.size)
    if (this.hasDropzoneTarget) this.dropzoneTarget.classList.add("hidden")
    if (this.hasPreviewTarget) this.previewTarget.classList.remove("hidden")
  }

  clear() {
    this.inputTarget.value = ""
    if (this.hasPreviewTarget) this.previewTarget.classList.add("hidden")
    if (this.hasDropzoneTarget) this.dropzoneTarget.classList.remove("hidden")
  }

  formatSize(bytes) {
    if (bytes < 1024) return `${bytes} B`
    if (bytes < 1048576) return `${(bytes / 1024).toFixed(1)} KB`
    return `${(bytes / 1048576).toFixed(1)} MB`
  }
}